<div class="dialog-header">
    <h2>Reject Reasons</h2>
    <ng-icon name="heroXMark" mat-dialog-close class="cursor-pointer"></ng-icon>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
    <div *ngIf="loading" class="loading-container">
        <mat-spinner diameter="30"></mat-spinner>
        <p>Loading rejection reasons...</p>
    </div>
    
    <div *ngIf="!loading && rejectionReasons.length === 0" class="no-reasons">
        <p>No rejection reasons found.</p>
    </div>
    
    <div *ngIf="!loading && rejectionReasons.length > 0" class="rejection-reasons-list">
        <div *ngFor="let item of rejectionReasons; let i = index" class="rejection-reason-item">
            <div class="reason-header">
                <span class="reason-date" *ngIf="item.date">{{ item.date }}</span>
            </div>
            <div class="reason-text">
            <span class="reason-number">{{ i + 1 }}.</span>
                {{ item.reason }}
            </div>
            <mat-divider *ngIf="i < rejectionReasons.length - 1" class="reason-divider"></mat-divider>
        </div>
    </div>
</mat-dialog-content>